import React, { useState } from "react"
import * as Icons from "lucide-react"

const pad = n => String(n).padStart(2, "0")
const todayStr = () => {
  const d = new Date()
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export default function EmailMeeting({
  onClose,
  defaultAttendees = "",
  showToast,
}) {
  const [title, setTitle] = useState("Meeting")
  const [date, setDate] = useState(todayStr())
  const [start, setStart] = useState("10:00")
  const [duration, setDuration] = useState(30)
  const [location, setLocation] = useState("")
  const [attendees, setAttendees] = useState(defaultAttendees || "")
  const [notes, setNotes] = useState("")

  const buildDates = () => {
    const [y, m, d] = date.split("-").map(Number)
    const [hh, mm] = start.split(":").map(Number)
    const s = new Date(y, (m || 1) - 1, d || 1, hh || 0, mm || 0)
    const e = new Date(s.getTime() + duration * 60000)
    const fmt = dt =>
      `${dt.getFullYear()}${pad(dt.getMonth() + 1)}${pad(dt.getDate())}T${pad(
        dt.getHours()
      )}${pad(dt.getMinutes())}00`
    return `${fmt(s)}/${fmt(e)}`
  }

  const openGoogle = () => {
    const params = new URLSearchParams({
      action: "TEMPLATE",
      text: title || "Meeting",
      dates: buildDates(),
      details: notes || "",
      location: location || "",
    })
    const emails = attendees
      .split(/[,;\s]+/)
      .map(s => s.trim())
      .filter(Boolean)
    if (emails.length) params.set("add", emails.join(","))
    window.open(
      `https://calendar.google.com/calendar/render?${params.toString()}`,
      "_blank"
    )
    showToast &&
      showToast("Opening Google Calendar to schedule the meeting…", "success")
    onClose && onClose()
  }

  const downloadIcs = () => {
    const [dtStart, dtEnd] = buildDates().split("/")
    const ics = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//BharatATS//Mail//EN",
      "BEGIN:VEVENT",
      `SUMMARY:${title || "Meeting"}`,
      `DTSTART:${dtStart}`,
      `DTEND:${dtEnd}`,
      location ? `LOCATION:${location}` : "",
      notes ? `DESCRIPTION:${notes.replace(/\n/g, "\\n")}` : "",
      ...attendees
        .split(/[,;\s]+/)
        .map(s => s.trim())
        .filter(Boolean)
        .map(a => `ATTENDEE:mailto:${a}`),
      "END:VEVENT",
      "END:VCALENDAR",
    ]
      .filter(Boolean)
      .join("\r\n")
    const blob = new Blob([ics], { type: "text/calendar" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `${(title || "meeting").replace(/[^\w -]/g, "")}.ics`
    a.click()
    URL.revokeObjectURL(url)
  }

  return (
    <div className="em-search-overlay" onClick={onClose}>
      <div className="em-meeting" onClick={e => e.stopPropagation()}>
        <div className="em-meeting-head">
          <div className="em-meeting-title">
            <Icons.CalendarPlus size={18} /> Schedule a Meeting
          </div>
          <button className="em-meeting-x" onClick={onClose}>
            <Icons.X size={18} />
          </button>
        </div>
        <div className="em-meeting-body">
          <label>Title</label>
          <input
            value={title}
            onChange={e => setTitle(e.target.value)}
            placeholder="Meeting title"
          />
          <div className="em-meeting-row">
            <div>
              <label>Date</label>
              <input
                type="date"
                value={date}
                onChange={e => setDate(e.target.value)}
              />
            </div>
            <div>
              <label>Start</label>
              <input
                type="time"
                value={start}
                onChange={e => setStart(e.target.value)}
              />
            </div>
            <div>
              <label>Duration</label>
              <select
                value={duration}
                onChange={e => setDuration(Number(e.target.value))}
              >
                <option value={15}>15 min</option>
                <option value={30}>30 min</option>
                <option value={45}>45 min</option>
                <option value={60}>1 hour</option>
                <option value={90}>1.5 hours</option>
                <option value={120}>2 hours</option>
              </select>
            </div>
          </div>
          <label>Attendees (emails)</label>
          <input
            value={attendees}
            onChange={e => setAttendees(e.target.value)}
            placeholder="name@company.com, name2@company.com"
          />
          <label>Location / Link</label>
          <input
            value={location}
            onChange={e => setLocation(e.target.value)}
            placeholder="Meeting room or video link"
          />
          <label>Notes / Agenda</label>
          <textarea
            value={notes}
            onChange={e => setNotes(e.target.value)}
            rows={3}
            placeholder="Agenda…"
          />
        </div>
        <div className="em-meeting-foot">
          <button className="em-meeting-google" onClick={openGoogle}>
            <Icons.Calendar size={15} /> Add to Google Calendar
          </button>
          <button
            className="em-meeting-ics"
            onClick={downloadIcs}
            title="Download .ics invite"
          >
            <Icons.Download size={15} /> .ics
          </button>
          <button className="em-meeting-cancel" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
